<template>
  <div class="p-4">
    <h2 class="text-2xl font-bold mb-4"> {{ $t('wishlist.myWishlist') }}</h2>

    <div v-if="wishlistProducts.length === 0" class="text-gray-500 flex justify-center items-center">
       {{ $t('wishlist.yourWishlistIsEmpty') }}
    </div>

    <div v-else class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
      <ProductCard
        v-for="product in wishlistProducts"
        :key="product.id"
        :product="product"
        :isInWishlist="true"
        @toggle-wishlist="toggleWishlist"
      />
    </div>
  </div>
</template>

<script>
import { ref, onMounted, inject, computed } from 'vue'
import api from '@/api'
import ProductCard from '@/components/ProductCard.vue'

export default {
  name: 'WishListPage',
  components: { ProductCard },
  setup() {
    const cartStore = inject('cartStore')
    const allProducts = ref([])

    const fetchProducts = async () => {
      try {
        const response = await api.get('/v1/items')
        allProducts.value = response.data.map(item => ({
          id: item.id,
          name: item.title,
          description: item.description,
          price: parseFloat(item.price),
          images: Array.isArray(item.image) ? item.image : JSON.parse(item.image),
          discount: item.discount || null,
          rating: 4,
          reviews: item.fields?.length || 0,
          category_id: item.category?.id ?? null,
          sub_category_id: item.sub_category?.id ?? null,
          created_at: item.created_at || new Date().toISOString(),
          user_id: item.user?.id ?? null
        }))
      } catch (error) {
        console.error('Failed to fetch products:', error)
      }
    }

    onMounted(fetchProducts)

    const wishlistProducts = computed(() =>
      allProducts.value.filter(p => cartStore.wishlistItems.includes(p.id))
    )

    const toggleWishlist = (productId) => {
      cartStore.toggleWishlist(productId)
    }

    return {
      wishlistProducts,
      toggleWishlist
    }
  }
}
</script>
